import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'

import { FilterAjEvents } from 'containers/filters'
import { apiAjEvents } from 'helpers/decorators/api'
import { AJEventsTable } from 'components/sections/adventurous-journeys'
import { meta, tableCommon } from 'helpers/decorators'
import config from 'config'

const enhance = compose(
  meta({
    title: 'All AJ Events',
    intlKey: 'pageTitle.all_aj_events'
  }),
  apiAjEvents({
    list: true,
    cache: false,
    useCommonLimit: true,
    hideIncompleteData: true,
    listReadParams: 'ORGANIZATION_NAME'
  }),
  tableCommon()
)

class AjEventsAll extends Component {
  static propTypes = {
    hideNewButton: PropTypes.bool,
    ajEvents: PropTypes.object.isRequired,
    setAjEventsParams: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func
  }

  static defaultProps = {
    params: {},
    hideNewButton: true
  }

  render() {
    const { params, hideNewButton, ajEvents, setCommonLimit, ...rest } = this.props

    return (
      <div>
        <FilterAjEvents />
        <div className="text--right base-margin">
          {!hideNewButton &&
            <Link
              className="btn"
              to={`${config.publicPath}/adventurous-journeys/new?organizationId=${params.id}`}
            >
              <FormattedMessage id="button.new_aj_event" />
            </Link>}
        </div>
        <AJEventsTable
          {...rest}
          ajEvents={ajEvents}
          params={params}
          list={ajEvents.list}
          loading={ajEvents.loading}
          offset={ajEvents.offset}
          limit={ajEvents.limit}
          setCommonLimit={setCommonLimit}
          pages={ajEvents.pages}
          sort={ajEvents.sort}
          setAjEventsParams={this.props.setAjEventsParams}
        />
      </div>
    )
  }
}

export default enhance(AjEventsAll)
